<script>
  import CookieLaw from 'vue-cookie-law'

  export default {
    components : {
      CookieLaw,
    },

    computed : {
      cfg () {
        return {
          show_cookie_warning : this.fwConfigs['general_show_cookie_warning'],
        }
      },
    },
  }
</script>

<style lang="stylus">
.b-CookieLaw
  &-hide-on-print
    @media print
      display: none !important
</style>

<template>
  <cookie-law
    v-if="cfg.show_cookie_warning"
    class="b-CookieLaw-hide-on-print"
  >
    <template v-slot:message>
      <div>
        We use cookies to helps us improve, and protect our services. By continuing to use this site, you agree to our <router-link :to="'/privacy-policy'" :target="$vuetify.breakpoint.mdAndUp ? '_blank' : '_self'">privacy policy</router-link>
      </div>
    </template>
  </cookie-law>
</template>
